import smoothscroll from 'smoothscroll-polyfill'
import ArrayFrom from 'array-from'
import './backToTop.js'

export default {
  init() {
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};

// Tabulate component from old LH website so that it works as it is when we migrate all posts. 
new class PostAnchors {
  constructor() {
    let contentEl = document.querySelector('.post')
    if (contentEl) {
      let headings = ArrayFrom(contentEl.querySelectorAll('h2, h3'))
      if (headings) {
        headings.forEach((heading) => {
          if (!this.hasParent(heading, '.blog-form')) {
            let headingID = heading.textContent // innertext of link
            let compatibleID = headingID.toLowerCase().replace(/[^A-Z]+/ig, '-') // href
            heading.id = compatibleID
            heading.classList.add('post--anchors')
          }
        })
      }
    }
  }
  hasParent(elem, selector) {
    for (; elem && elem !== document; elem = elem.parentNode) {
      if (elem.matches(selector)) return true
    }
    return false
  }
}


export class Tabulate {
  constructor(el) {
    let contentEl = document.querySelector('.post')
    if (contentEl) {
      let loadel = contentEl.querySelector('.tabulate--loading')
      let headings = ArrayFrom(contentEl.querySelectorAll('h2'))
      if (headings) {
        let includeSub = el.getAttribute('subheadings')
        let unOrdered = el.getAttribute('numbered')
        let compactView = el.getAttribute('compact')
        let includeH3 = false
        let listNumbered = true
        let showCompact = false
        if (includeSub && includeSub === 'true') {
          includeH3 = true
        }
        if (unOrdered && unOrdered === 'false') {
          listNumbered = false
        }
        if (compactView && compactView === 'true') {
          showCompact = true
        }
        var headingData = []

        headings.forEach((heading) => {
          if (!this.hasParent(heading, '.blog-form')) {
            let headingID = heading.textContent // innertext of link
            let compatibleID = headingID.toLowerCase().replace(/[^A-Z]+/ig, '-') // href
            let link = []
            link.push('<a href="#' + compatibleID + '">' + headingID + '</a>') // Heading 2
            let selector = 'H2'
            let filter = 'H3'
            if (includeH3 === true) {
              link.push(this.nextUntil(heading, selector, filter))
              headingData.push(link)
            } else {
              headingData.push(link) // only for h2s
            }
          }
        })
        if (headingData.length > 0) {
          // Create table
          this.makeTOC(headingData, el, listNumbered, () => {
            smoothscroll.polyfill()
            loadel.classList.add('loaded')
            el.classList.add('loaded')
            if (showCompact === true) {
              el.classList.add('compact')
            }
          })
          // Smooth scroll
          const linksToAnchors = ArrayFrom(el.querySelectorAll('a[href^="#"]'))
          linksToAnchors.forEach(each => (each.onclick = this.anchorLinkHandler))
        } else {
          loadel.classList.add('loaded')
        }
      }
    }
  }

  hasParent(elem, selector) {
    for (; elem && elem !== document; elem = elem.parentNode) {
      if (elem.matches(selector)) return true
    }
    return false
  }

  nextUntil(elem, selector, filter) {

    // Setup siblings array
    var siblings = []

    // Get the next sibling element
    elem = elem.nextElementSibling
    // As long as a sibling exists
    while (elem) {
      // If we've reached our match, bail
      if (elem.tagName.toString() === selector) break

      // If filtering by a selector, check if the sibling matches
      if (filter && elem.tagName.toString() !== filter) {
        elem = elem.nextElementSibling
        continue
      }

      let elemOrg = elem.textContent // innertext of link
      let elemID = elemOrg.toLowerCase().replace(/[^A-Z]+/ig, '-') // href
      let elemLink = '<a href="#' + elemID + '">' + elemOrg + '</a>'
      // Otherwise, push it to the siblings array
      siblings.push(elemLink)

      // Get the next sibling element
      elem = elem.nextElementSibling

    }
    if (siblings.length > 0) {
      return siblings
    }
  }

  makeTOC(array, el, numbered, cb) {
    // Create the list element
    var list = document.createElement('ul')
    // Check for numbered or default list
    if (numbered) {
      list.classList.add('list', 'list--toc')
    } else {
      list.classList.add('list-unstyled')
    }
    // Loop through all H2's from data array
    for (var i = 0; i < array.length; i++) {
      // Create the list item:
      var item = document.createElement('li')
      item.classList.add('small')
      let count = i + 1
      if (numbered) {
        item.innerHTML = count + '.&nbsp;&nbsp;' + array[i][0]
      } else {
        item.innerHTML = array[i][0]
      }
      if (array[i][1]) {
        let subHeading3 = document.createElement('ul')
        subHeading3.classList.add('list', 'list--inner')
        for (var j = 0; j < array[i][1].length; j++) {
          let heading3 = document.createElement('li')
          if (numbered) {
            let subLiCount = j + 1
            let subCount = count + '.' + subLiCount
            heading3.innerHTML = subCount + '.&nbsp;&nbsp;' + array[i][1][j]
          } else {
            heading3.innerHTML = array[i][1][j]
          }

          subHeading3.appendChild(heading3)
        }
        item.appendChild(subHeading3)
      }

      // Set its contents:
      list.appendChild(item)
    }

    // Finally, return the constructed list:
    el.appendChild(list)
    cb()
  }

  anchorLinkHandler(e) {
    const distanceToTop = el => Math.floor(el.getBoundingClientRect().top);

    e.preventDefault()
    const targetID = this.getAttribute('href')
    const targetAnchor = document.querySelector(targetID)
    if (!targetAnchor) return
    const originalTop = distanceToTop(targetAnchor) // Height of fixed header

    window.scrollBy({
      top: originalTop,
      left: 0,
      behavior: 'smooth',
    });

    const checkIfDone = setInterval(function () {
      const atBottom = window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 2
      if (distanceToTop(targetAnchor) === 0 || atBottom) {
        targetAnchor.tabIndex = '-1'
        // targetAnchor.focus()
        window.history.pushState('', '', targetID)
        clearInterval(checkIfDone)
      }
    }, 100)
  }
}

const elements = ArrayFrom(document.querySelectorAll('.tabulate'))
if (elements[0]) {
  new Tabulate(elements[0])
}



// WEBPACK FOOTER //
// ./scripts/routes/singlePost.js